import React from 'react';

export const serviceNoticeContent = (
  <div>
    <p>
      <strong>Note:</strong> Your active service end date is also known as your
      separation date. This can be found in the record of service section of
      your DD214. If your service is or was in the National Guard or Reserve,
      your active service end date could be different from when your contract or
      service obligation ends.
    </p>
  </div>
);
